<template>
    <Slide :title="title" :subtitle="subtitle">
        <div class="cr:md:mx-[7rem]">
            <p class="cr:text-center cr:font-bold cr:pb-2">${{ budget }}/Month</p>
            <InputRange :max="max" :min="min" :step="50" max-suffix="+" v-model="budget"></InputRange>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import {ref, computed} from "vue";
import Slide from "@/components/slides/Slide.vue";
import InputRange from "@/components/elements/InputRange.vue";

const min = 50;
const max = 5000;
const budget = ref(500);

const props = defineProps({
    title: {
        type: String,
        default: 'Whats your monthly budget?'
    },
    subtitle: {
        type: String,
        default: 'We tailor your spend to fit the needs of your business.'
    }
});

const slidePayload = computed(() => {
    return {
        monthly_budget: budget.value,
    }
});
const validate = () => true;
const canContinue = computed(() => true);

defineExpose({
    canContinue,
    slidePayload,
    validate
});

</script>